import React from 'react';
import useTheme from '../../../hooks/useTheme';
import './ThemeToggle.css';

/**
 * 日夜主题切换按钮
 * 纯 SVG 动画，太阳 ↔ 月亮平滑变形
 */
const ThemeToggle = ({ size = 22 }) => {
  const { toggleTheme, isDark } = useTheme();

  return (
    <button
      className={`theme-toggle-btn ${isDark ? 'is-dark' : 'is-light'}`}
      onClick={toggleTheme}
      aria-label={isDark ? '切换到浅色模式' : '切换到深色模式'}
      title={isDark ? '切换到浅色模式' : '切换到深色模式'}
    >
      <svg
        className="theme-toggle-svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {/* 太阳/月亮中心圆 */}
        <circle
          className="toggle-center"
          cx="12"
          cy="12"
          r={isDark ? 4 : 5}
        />
        {/* 月亮遮罩 - 深色模式时出现 */}
        <circle
          className="toggle-mask"
          cx={isDark ? 15 : 12}
          cy={isDark ? 9 : 12}
          r={isDark ? 4 : 0}
          fill="currentColor"
          stroke="none"
        />
        {/* 太阳光线 - 浅色模式时出现 */}
        <g className="toggle-rays">
          <line x1="12" y1="1" x2="12" y2="3" />
          <line x1="12" y1="21" x2="12" y2="23" />
          <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
          <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
          <line x1="1" y1="12" x2="3" y2="12" />
          <line x1="21" y1="12" x2="23" y2="12" />
          <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
          <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
        </g>
      </svg>
    </button>
  );
};

export default ThemeToggle;
